import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Features() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 10000,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10,
    cssEase: "linear",
    centerMode: false,
    arrows: false,

    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return (
    <>
      <section className="position-relative text-center">
        <h2 className="hadding hadding_bg d-inline-block mb-0" data-aos="fade-up">Featured In</h2>
      </section>

      <section className="featured_icon ps-3 pe-3">
        <div className="row     align-items-center">
        <Slider {...settings}>
          <div className=" featured_icon_box">
            <img src="/assets/img/f1.png" alt="logo" className="img-fluid" data-aos="fade-up" />
          </div>
          <div className=" featured_icon_box">
            <img src="/assets/img/f2.png" alt="logo" className="img-fluid" data-aos="fade-up"/>
          </div>
          <div className=" featured_icon_box">
            <img src="/assets/img/f3.png" alt="logo" className="img-fluid" data-aos="fade-up"/>
          </div>
          <div className="col-md-2 col-6 featured_icon_box">
            <img src="/assets/img/f4.png" alt="logo" className="img-fluid" data-aos="fade-up"/>
          </div>
          <div className=" featured_icon_box">
            <img src="/assets/img/f5.png" alt="logo" className="img-fluid" data-aos="fade-up"/>
          </div>
          <div className="featured_icon_box">
            <img src="/assets/img/f6.png" alt="logo" className="img-fluid" data-aos="fade-up"/>
          </div>
          </Slider>
        </div>
      </section>
    </>
  );
}

export default Features;
